import type { AxiosInstance } from 'axios'

import { FrontendSetting } from '../../interfaces/setting'

export const updateFrontendSetting = (api: AxiosInstance) => (
  frontendSetting: FrontendSetting
): Promise<FrontendSetting> =>
  api.put('/v1.0/admin/settings/frontend', frontendSetting)
